import React from 'react';

import { canAccessBroadcast } from '@lumapps/broadcasts/ducks/selectors';
import { doesCurrentUserHaveAccessToCustomContentTypes } from '@lumapps/content-types/ducks/selectors';
import { isPageWriterAgentEnabled as isPageWriterAgentEnabledSelector } from '@lumapps/designer-agent/ducks/selectors';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';

import {
    ContributionMenu as ContributionMenuUI,
    ContributionMenuProps as ContributionMenuUIProps,
} from './ContributionMenu';

type ConnectedProps = Omit<
    ContributionMenuUIProps,
    'doesHaveAccessToCCT' | 'isCreateBroadcastEnabled' | 'isPageWriterAgentEnabled'
>;

export const ContributionMenu: React.FC<ConnectedProps> = (props) => {
    const doesCurrentUserHaveAccessToCCT = useSelector(doesCurrentUserHaveAccessToCustomContentTypes);
    const isSuperAdmin = useSelector(isInstanceSuperAdmin);
    const isCreateBroadcastEnabled = useSelector(canAccessBroadcast);
    const isPageWriterAgentEnabled = useSelector(isPageWriterAgentEnabledSelector);

    const doesHaveAccessToCCT = isSuperAdmin || doesCurrentUserHaveAccessToCCT;

    return (
        <ContributionMenuUI
            {...props}
            doesHaveAccessToCCT={doesHaveAccessToCCT}
            isCreateBroadcastEnabled={isCreateBroadcastEnabled}
            isPageWriterAgentEnabled={isPageWriterAgentEnabled}
        />
    );
};

ContributionMenu.displayName = 'ContributionMenuConnected';
